import React from 'react'
import '../api/firebase'

import AppRouter from "../routers/AppRouter"

const App = () => {
  return (
    <AppRouter />
  )
}

export default App
